module.exports = __webpack_public_path__ + "img/trading-view.1863bf80.svg";